import { createFileRoute } from '@tanstack/react-router'
import SolutionsPage from '@/pages/solutions'
import { buildHead } from '@/shared/seo/seo-config'
import { redirectIfPublicPageHidden } from '@/shared/lib/hidden-public-pages'

export const Route = createFileRoute('/$lang/solutions')({
  beforeLoad: ({ params }) =>
    redirectIfPublicPageHidden('solutions', params.lang),
  head: ({ params }) => buildHead('solutions', params.lang),
  component: SolutionsPage,
  staticData: { layout: 'public' },
})
